// extracted by mini-css-extract-plugin
export var banner = "_lz-0";
export var settingRow = "_lz-2";
export var titleIcon = "_lz-1";